module.exports = __webpack_public_path__ + "static/media/depoimento-curso-sushi-2.71c617c2.png";